import styled from 'styled-components'
import Image from 'common/image'
import IosDownloadQR from 'assets/ios_download_qr.svg'
import DownloadIcon from 'assets/download_icon.svg'
import { useTranslation } from 'react-i18next'
import { adobeInteractionEvent } from 'utils/adobewa'

const HowToJoinContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 1164px;
    margin-top: 24px;
    margin-bottom: 80px;
`

const BoxContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 48px;
    align-items: center;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 1px 1px 15px 0 rgba(0, 0, 0, 0.1);
`

const UpperSection = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-start;
`

const LeftSection = styled.div`
    width: 520px;
`

const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 56px;
`

const TitleText = styled.div`
    color: #121b21;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
`

const TitleUnderLine = styled.div`
    width: 80px;
    height: 5px;
    background: #d9c277;
`

const DisclaimerText = styled.div`
    margin-top: 40px;
    color: #003c84;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`

const DescriptionText = styled.div`
    margin-top: 16px;
    color: #4e3821;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const RightSection = styled.div`
    margin-left: 48px;
`

const DownloadArea = styled.div`
    width: 100%;
    margin-top: 40px;
    display: flex;
    flex-direction: row;
`

const ScanToDownload = styled.div`
    width: 247px;
`

const DownloadText = styled.div`
    color: #4e3821;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px; /* 125% */
`

const DownloadQRcode = styled.div`
    margin-top: 16px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`

const DownloadButton = styled.div`
    margin-top: 16px;
    display: flex;
    height: 55px;
    padding: 8px 48px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 50px;
    border: 1px solid #c5924d;
    background: #fff;
    cursor: pointer;
`

const DownloadButtonText = styled.div`
    color: #c5924d;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px; /* 125% */
`

const Gap = styled.div`
    width: 40px;
`

const ClickToDownload = styled.div`
    width: 203px;
`

const VideoArea = styled.div`
    width: 520px;
    height: 338px;
`

// const JoinUsButton = styled.div`
//     margin-top: 48px;
//     width: 296px;
//     display: flex;
//     min-height: 55px;
//     padding: 8px 48px;
//     justify-content: center;
//     align-items: center;
//     border-radius: 200px;
//     background: #c5924d;
//     cursor: pointer;
// `

// const JoinUsText = styled.div`
//     color: #fff;
//     font-size: 16px;
//     font-style: normal;
//     font-weight: 700;
//     line-height: 20px; /* 125% */
// `

export default function HowToJoin() {
    const { t, i18n } = useTranslation('', {
        keyPrefix: 'homepage.howtojoinwidget',
    })
    const lang = i18n.language

    const openLinkInNewTab = (url: string) => {
        adobeInteractionEvent({
            lang: lang,
            eventID: `prioritysite_click_Program_JoinProgram_Download`,
        })

        window.open(url, '_blank')?.focus()
    }

    // const videoOnplay = (url: string) => {
    //     adobeInteractionEvent({
    //         lang: lang,
    //         eventID: `prioritysite_clickPlayVideo_Program_JoinProgram_Video`,
    //         videoFileName: url,
    //     })
    // }

    return (
        <HowToJoinContainer>
            <BoxContainer>
                <UpperSection>
                    <LeftSection>
                        <TitleContainer>
                            <TitleText>{t(`titletext`)}</TitleText>
                            <TitleUnderLine />
                        </TitleContainer>
                        <DisclaimerText>{t(`disclaimer`)}</DisclaimerText>
                        <DescriptionText>{t(`description`)}</DescriptionText>
                        <DownloadArea>
                            <ScanToDownload>
                                <DownloadText>{t(`scandownload`)}</DownloadText>
                                <DownloadQRcode>
                                    <Image
                                        src={IosDownloadQR}
                                        width={116}
                                        height={116}
                                        alt="ios download qr code"
                                    />
                                </DownloadQRcode>
                            </ScanToDownload>
                            <Gap />
                            <ClickToDownload>
                                <DownloadText>
                                    {t(`buttonfordownload`)}
                                </DownloadText>
                                <DownloadButton
                                    onClick={() =>
                                        openLinkInNewTab(
                                            lang === 'zh'
                                                ? 'https://m.hkjc.com/tc/download.html?target=classic-3-in-1'
                                                : 'https://m.hkjc.com/en/download-classic-3-in-1.html'
                                        )
                                    }
                                >
                                    <DownloadButtonText>
                                        {lang === 'zh' ? '下載' : 'DOWNLOAD'}
                                    </DownloadButtonText>
                                    <Image
                                        src={DownloadIcon}
                                        width={18}
                                        height={18}
                                        alt="download icon"
                                    />
                                </DownloadButton>
                            </ClickToDownload>
                        </DownloadArea>
                    </LeftSection>
                    <RightSection>
                        <VideoArea>
                            {/* <video
                                title="tutorial of join program"
                                controls
                                style={{
                                    objectFit: 'cover',
                                    width: '100%',
                                    height: '100%',
                                    borderRadius: '25px',
                                    border: '0px',
                                }}
                                src={t('video')}
                                onPlay={() => {
                                    videoOnplay(t(`video`))
                                }}
                            /> */}
                            <Image
                                src={t('video')}
                                width={500}
                                height={333}
                                style={{ borderRadius: '25px' }}
                                alt="How To Join banner"
                            />
                        </VideoArea>
                    </RightSection>
                </UpperSection>
                {/* <JoinUsButton>
                    <JoinUsText
                        onClick={() => joinningUsButtonClick(t(`buttonUrl`))}
                    >
                        {t(`buttonText`)}
                    </JoinUsText>
                </JoinUsButton> */}
            </BoxContainer>
        </HowToJoinContainer>
    )
}
